import { ProductGame } from "./common";
import { ProductIdentity } from "./data/collections";

export enum PurchaseState {
  NOT_FOUND = "not_found",
  LOADING = "loading",
  READY = "ready",
  NOT_ENABLED = "not_enabled",
  REQUIREMENTS_NOT_MET = "requirements_not_met",
  ALREADY_OWNED = "already_owned",
  UNSUPPORTED_REGION = "unsupported_region",
  GAME_ACCOUNT_NOT_FOUND = "game_account_not_found",
  SERVER_ERROR = "server_error",
}

export type PurchaseData = {
  balance: number;
  affiliateName: string | undefined;
  products: ProductDetail[];
};

export type ProductDetail = {
  gameId: ProductGame;
  productId: string;
  name: string;
  productType: string;
  productSlug: string;
  type: string;
  thumbnailUrl?: string;
  cost: number | null;
  price: number | null;
};
export type IndividualProductResponse = {
  identity: ProductIdentity;
  state: PurchaseState;
  cost: number | null;
  price: number | null;
  contents?: {
    productIdentity: ProductIdentity;
    prices: { price: number; cost: number; currency: string }[];
  }[];
};

export type usePurchaseInfoResponse = {
  products: IndividualProductResponse[];
  ownedItems: string[] | undefined;
  affiliateName: string | undefined;
  balance: number;
  state: PurchaseState;
  purchasing: boolean;
  initiatePurchase: (identity: ProductIdentity, purchaseData: PurchaseData) => Promise<unknown>;
};
